export default {
  app_name: '포켓튜터',

  mission: {
    hide_mission_popup_today: '미션 안내 오늘 하루 안보기',
    hide_notice_popup_today: '공지 안내 오늘 하루 안보기',
    mission_to_do: '해야 할 미션!!',
    our_school_lect: '우리학교 강의',
    today_quest: 'Today`s Quest',
    desc_new_mission: "새 미션이 있어요!",
    state_desc_deadline: "기간이 지났어요!",
    desc_finished_mission: "미션완료",
    listen_mission: "듣기",
    note_mission: "노트 등록",
    finished_mission_desc: "%s(%s%s, %s 학년):미션(%s/%s) %s에 완료됨",
    received_stamp_state: "%s님이 칭찬도장 %d포인트 적립",
    note_state: "%s님이 노트를 등록하셨습니다!",
  },
  header_tooltip: {
    point: '사용 가능한 포인트!',
    greeting_1: '환영합니다!',
    greeting_2: '언제나 화이팅입니다!',
    greeting_3: '오랜만에 반가워요!',
    note: '내가 만든 노트',
    textbook: '내가 만든 교과서',
    usable_point: '사용 가능한 포인트!',
    playlist: '플레이리스트에 온걸 환영합니다.',
    title_point: '%sP',
    title_stamp: '%s개',
    title_book: '%s권',
  },
  common: {
    login: "로그인",
    confirm: "확인",
    next: "다음",
    cancel: "취소",
    ok: "확인",
    back: "Back",
    phone_type: {
      skt: "SKT",
      kt: "KT",
      lgu: "LGU+",
      ch_phone: "알뜰폰",
    },
    school: {
      elem: "초등",
      middle: "중등",
      grade: "학년",
      class: "반"
    },
    school1: {
      elem: "초",
      middle: "중",
    },
    grade: {
      pri: "pri",
      mid: "mid",
      sum: "sum"
    },

    date: {
      y: "년",
      m: "월",
      d: "일",
    },
    new: "New",
    register: "등록",
    like: "좋아요",
    unlike: "싫어요",
    reply: "답글",
    report: "신고하기",
    view_all: "전체보기",
    view_all_comment: " %s 댓글 모두보기",
    view_more: "더보기",
    view_less: "간략보기",
    placeholder: "한마디를 입력하세요.",
    online: '온라인',
    offline: '오프라인',
    busy: '자리비움',
    notice: '공지사항',
    no_data_in_list : '검색된 데이터가 없습니다.',
    hamburger_menu_voucher: '내 이용권',
    school_desc: "%s %d 학년 %s",
    reward_popup_greeting: '오늘도 출석하셨군요!! 반갑습니다.',
    mission_popup_greeting: '오늘도 힘차게 시작해보죠!!',
    this_week_attendance: '이번주 출석',
    my_point:'나의 포인트',
    new_badge: 'NEW',
    select_school: "학교를 선택하세요",
    input_school_name_search: "검색할 학교이름을 입력하세요.",
  },

  intro: {
    look_around_without_login: "로그인 없이 둘러보기",
  },

  login: {
    id: "아이디",
    login: "로그인",
    password: "비밀번호",
    signup: "회원가입",
    find_password: "비밀번호 찾기",
    find_id: "아이디 찾기"
  },

  find_id: {
    find_id: "아이디 찾기",
    student_name: "이름",
    please_enter_your_real_name: "실명을 입력해 주세요.",
    parent_cell_phone_number: "학부모 휴대폰 번호",
    please_enter_without: "'-'빼고 입려해 주세요.",
    please_enter_the_verification_code: "인증번호를 입력해주세요.",
    send_verification_code: "인증번호 발송",
    find_id_alert_content: "입력하신 정보는 본인확인 용도로만 사용되며, 그 용도 이외로는 사용 되거나 저장되지 않습니다.",
    input_your_name_please: "이름을 입력해주세요",
    authorization_code_sent: "인증번호가 발송되었습니다.",
    authentication_is_complete: "인증번호가 발송 되었습니다.",
    no_matching_member_info: "일치하는 회원정보가 없습니다.",
    please_verify_mobile_number: "휴대폰 번호를 인증해 주세요.",
  },

  find_password: {
    find_password: "비밀번호 찾기",
    top_hint: "비밀번호를 찾고자 하는 아이디를 입력해주세요.",
    id: "아이디",
    please_enter_your_id: "아이디를 입력해 주세요.",
    id_help: "입력하신 정보는 본인확인 용도로만 사용되며, 그 용도 이외로는 사용 되거나 저장되지 않습니다.",
    what_if_cant_remember_id: "아이디가 기억나지 않는다면?",
    find_id: "아이디 찾기",
  },

  change_password: {
    change_password: "비밀번호 변경",
    please_reset_your_password: "비밀번호를 재설정해주세요.",
    new_password: "새 비밀번호",
    new_password_hint: "8~16자 영문 대 소문자, 숫자, 특수문자를 사용하세요.",
    reconfirm_new_password: "새 비밀번호 재확인",
    please_reenter: "다시 한번 입력해 주세요.",
    bottom_help: "비밀번호를 바꾸면, 모바일 기기에서 모두 로그아웃 됩니다.\n새로운 비밀번호로 다시 로그인해주세요.",
    password_changed_successfully: "비밀번호가 성공적으로 번경되었습니다.",
  },

  agree_to_terms: {
    agree_to_terms: "약관동의",
    top_help: "이용약관, 개인정보 수집 및 이용, 프로모션 안내 수신에 모두 동의해 주세요.",
    agree_to_all: "전체동의",
    terms1: "포켓튜터 이용약관 동의 (필수)",
    terms2: "개인정보 수집 및 이용에 대한 안내 (필수)",
    terms3: "이벤트 등 프로모션 알림 수신 (선택)",
  },

  signup: {
    enter_info: "정보입력",
    required_field: "필수 입역사항입니다.",
    id: "아이디",
    please_enter_your_id: "아이디를 입력해 주세요.",
    dbl_chk: "중복확인",
    password: "비밀번호",
    password_hint: "영문 대 소문자, 숫자, 특수문자 조합 8~16자리",
    reconfirm_password: "비밀번호 재확인",
    reconfirm_password_hint: "비밀번호를 다시 한번 입력하세요.",
    nickname_to_use: "사용할 닉네임",
    please_enter_your_nickname: "닉네임을 입력해 주세요.",
    nickname_hint: "닉네임을 설정하지 않을 시에는 본명으로 노출됩니다.",
    student_name: "이름",
    please_enter_your_real_name: "실명을 입력해 주세요.",
    student_gender: "학생 성별",
    man: "남",
    woman: "여",
    birthday: "생년월일",
    birthday_help: "만 14세 미만의 학생의 경우 포켓튜터 가입 시 법정대리인의 동의가 필요합니다. 포켓튜터 가입에 동의해주시길 바랍니다.",
    handphone_number: "핸드폰 번호",
    only_number_without: "'-' 를 제외 숫자만 입력",
    enter_verify_number: "인증번호 입력",
    send_v_code: "인증번호 발송",
    cfrm_v_code: "인증번호 확인",
    parent_name: "부모님 휴대폰 번호",
    enter_your_parents_names: "부모님 이름을 입력해 주세요.",
    parent_handphone_number: "부모님 휴대폰 번호",
    school_info: "학교정보",
    select_school: "학교선택",
    delivery_info: "배송 정보",
    recipient: "수령인",
    please_enter_the_recipient: "수령인을 입력하세요.",
    delivery_address: "배송지",
    register_your_post_code: "우편번호를 등록하세요.",
    search_postcode: "우편번호 검색",
    main_address: "기본주소",
    enter_detailed_address: "상세주소 입력",
    phone_number: "휴대전화",
    enter_only_numbers_without: "'-' 를 제외 숫자만 입력",
    please_select_a_request_for_delivery: "배송 요청사항(선택)",
    request: "요청사항",
    please_enter_delivery_request: "배송요청사항을 입력해주세요.",
    email: "이메일",
    email_hint: "이메일을 입력해 주세요.",
    recommender_id: "추천아이디",
    recommender_id_placeholder: "추천인이 있을 경우에 입력해 주세요.",
    recommender_id_hint: "추천인의 아이디 입력시, 추천인에게 마일리지가 적립됩니다.",
  },

  menu: {
    message_box: "메시지함",
    message_content: "메시지 내용",
    point_use_history: "포인트 사용 내역"
  },

  notice: {
    notice: "공지사항",
  },

  useful: {
    useful_info: "알쓸정보",
    comment_placeholder: "댓글을 입력하세요."
  },

  purchase: {
    buy_list: "구매 목록",
    buy_reward_product: "리워드 상품 구매",
    banner_area: "배너영역",
    daily_thing: "생활용품",
    furniture: "가구",
    food: "식품",
    etc: "기타",
    popular_product: "인기상품",
    buy: "구매하기",
    exchange_return_restriction: "교환/반품 제한사항",
    amount: "수량",
    OF: "주문완료",
    CF: "쿠폰발송완료",
    CW: "완료취소",
    order_no: "주무번호",
    order_dt: "주문일자",
    link_place: "배송주소",
    after_buy: "주문이 되었습니다!",
    after_cancel_buy: "주문이 취소되었습니다.",
    cancel_confirm:"주문을 취소하시겠습니까?"
  },

  community: {
    self_made_tb: "직접만든 교과서",
    playlist: "플레이리스트",
    board: "게시판",
    challenge: "챌린지",
    popular: "인기!",
    my_made_textbook: "내가 만든 교과서",
    recommend: "추천",
    please: "해주세요",
    my_made: "내가 만든",
    textbook: "교과서",
    mission: "미션",
    make_textbook: "교과서 만들기",
    make: "만들기",
    shuffle_play: "셔플재생",
    play_all: "전체재생",
    option_play: "옵션재생",
    select_all: "전체선택",
    diselect: "선택해제",
    board_search_placeholder: "제목 및 본문 검색",
    my_wrote: "내가 쓴 글",
    post_in_comment: "댓글 단 글",
    favorite_board: "즐겨찾는 게시판",
    new: "NEW",
    all_board: "전체 게시판",
    modify_post: "게시글 수정",
    write_post: "게시글 작성",
    public: "공개",
    anonymous: "익명",
    add_body_photo: "본문 사진추가",
    update_body_photo: "이미지변경",
    write_post_placeholder: "제목을 입력해주세요.",
    please_write_the_text: "본문을 작성해 주세요.",
    when_writing_the_text: "본문 작성시,사진추가하기를 통해 사진을 추가할 수 있습니다.",
    when_writing: "작성시",
    you_can_use: "를 사용 할 수 있습니다.",
    hashtag: "해시태그",
    write: "작성하기",
    delete: "삭제하기",
    modify: "수정하기",
    top: "TOP",
    hot: "HOT",
    other: "기타",
    participate: "참여하기",
    make_challenge: "챌린지 만들기",
    modify_challenge: "챌린지 수정",
    participate_challenge: "챌린지 참여",
    close_eyes_but_studying: "눈감고 있지만, 공부하고 있다.",
    target_participate: "목표 참여 인원",
    participate_reward: "참여보상",
    participating_persons: "목표 참여 인원",
    please_enter_challenge_title: "챌린지 제목을 입력해주세요.",
    add_cover_photo: "커버사진 추가하기",
    temporary_save: "임시저장",
    hours: "시간",
    mins: "분",
    please_enter_comment: "댓글을 입력하세요.",
    camera_library_area: "카메라/라이브러리 영역",
    please_enter_your_text: "본문을 입력해주세요.",
    ask_question: "질문하기",
    rate: "평가하기",
    play: "재생",
    put: "담기",
    search_title_and_text: "제목 및 본문 검색",
    challenge_placeholder: "듣는 챌린지 통합검색",
    after_make: "챌린지가 등록되었습니다.",
    after_participate_lated: "챌린지가 완료되었습니다. 보너스를 받으실 수 있습니다.",
    after_update: "챌린지가 수정되었습니다.",
    after_save: "챌린지가 저장되었습니다.",
    after_comment_add: "댓글이 등록되었습니다.",
    after_participate: "참여하였습니다.",
    alert_delete: "챌린지를 정말 삭제하시겠습니까?",
    alert_post_delete: "게시글을 삭제하시겠습니까?",
    please_enter_title: "제목을 입력해 주세요.",
    please_enter_content: "내용을 입력해 주세요.",
    please_enter_target: "목표 참여 인원을 설정해주세요.",
    please_enter_image: "사진을 등록해주세요.",
    M: "%s명",
    after_put: "등록되었습니다.",
    please_select_course: "강의를 선택해주세요.",
    after_post_delete: "게시글이 삭제되었습니다.",
    after_post_update: "게시글이 수정되었습니다.",
    after_post_make: "게시글이 등록되었습니다.",
    make_playlist_title: "새 플레이리스트 추가",
    report_title: "신고",
    playlist_img: "플레이리스트 이미지",
    name: "이름",
    reason: "신고사유",
    thumbnail: "이미지",
    name_placeholder: "이름을 입력해 주세요.",
    reason_placeholder: "신고사유를 입력하세요.",
    listen_image: "포켓튜터 이미지",
    file_image: "직접등록하기",
    search: "Searched Challenges",
    challenge_header_title: '#함께라면 할수 있어! \n#도전 챌린지',
    no_textbook: '아직 업로드된 교과서가 없습니다.\n여러분의 컨텐츠로 채워주세요 :)',
    participate_already: "이미 참여하였습니다."
  },

  curriculum: {
    elementary_lecture: "%s %d월 %d주차 강의",
    all_lecture: "전체강의",
    rest_lecture: "잔여강의",
    this_week: "이번주",
    ele_lecture: " 강의",
    finished_lecture: "완료한 강의",
    subject: {
      sum: "총",
      guk: "국",
      yong: "영",
      su: "수",
      sa: "사",
      bang: "방",
      ba: "바",
      gua: "과",
      oyk: "역",
    },
    week_popup_title: "전체 강의 일정",
    complete: "완료",
    incomplete: "미완료",
    proceeding: "진행중",
    month: "월",
    week_lecture: "주차 강의",
    two_track: "투트랙",
    all_courses: "전체강좌",
    select_all: "전체선택",
    question: "Question",
  },

  listen_teacher: {
    mission_to_do: "해야 할 미션",
    praise_stamp: "칭찬도장",
    savable_point: "적립가능 포인트",
    i_will_not: "안할래요!",
    start: "시작!",
    my_listen_note: "나의 듣는 노트",
    enter_title_or_subject: "검색하려는 노트에 제목 또는 과목명을 입력하세요.",
    nt_reg_date: "노트 등록일",
    reg_finish: "등록 완료",
    teacher_confirm_finish: "선생확인",
    mentoring_finish: "멘토링 완료",
    new_note: "새노트",
    subject: "과목",
    lecture_title: "강의제목",
    register_voice: "음성등록",
    other_file: "기타파일",
    load_file: "파일 불러오기",
    record: "녹음",
    stop: "중지",
    play: "플레이",
    done: "완료",
    reset: "재설정",
    file_name: "파일명",
    please_enter_content: "내용을 입력해 주세요.",
    modify_note: "노트 수정",
    create_note: "노트 등록",
    talk_to_teacher: "선생님과 대화",
    chatting: "채팅",
    curriculum_question: "교과질문",
    away: "자리비움",
    the_teacher_is_currently_away: "선생님이 현재 접속중입니다!",
    waiting_reply: "답변 대기중",
    reply_finish: "답변 완료",
    lect_qu: "강의질문",
    register_lecture_question: "강의질문 등록",
    please_enter_the_course_title: "강의 제목을 입력해 주세요.",
    please_enter_a_question_title: "질문 제목을 입력해 주세요.",
    register_question: "질문 등록",
    question_title: "질문 제목",
    question_answer: "질문 답변",
    teacher_word: "선생님 한마디",
    delete_question: "질문 삭제",
    no_registered_note: "등록된 노트가 없습니다.",
    register_photo: "사진등록",
    view_question: "질문보기",
    delete_question_confirm: "질문을 정막 삭제하시겠습니까?",
    send: "전송",
    chat_placeholder: "대화내용을 입력해주세요.",
    after_note_add: "노트가 정상적으로 등록되었습니다.",
    after_question_add: "질문이 등록되었습니다.",
    after_note_modify: "노트가 수정되었습니다.",
    register_new_note: "새 노트 등록",
    note_img_delete_confirm: "사진을 삭제하시겠습니까?",
    note_img_modify_confirm: "재등록하는 경우 기존 사진은 삭제 됩니다. 기존 사진을 삭제하고, 재등록하시겠습니까?",
    note_delete_confirm: "등록된 노트를 삭제하시겠습니까? 삭제 후에는 복구가 어렵습니다.",
    all: "전체",
    congratulations:"CONGRATULATIONS!!!",
    bonus_gain:"보너스획득"
  },
  home: {
    listening_note: "듣는 노트",
    best: "Best",
    elementary: "초등",
    middle: "중등",
    listen_teacher: "듣는 선생님과",
    with_mission: "함께하는 미션",
    popular_lecture: "인기강의",
    todays: "Today`s",
    quest: "Quest",
    spec_lecture: "기획특강",
    it_science: "IT 과학",
    remained_time_to_end: "시즌 종료까지 남은 시간",
    remained_time_to_next: "다음시즌 준비중입니다.",
    scheduled_reward_points: "예정 보상 포인트",
    point: "포인트",
    use: "사용하기",
    if_know: "알아두면 ",
    useful: "쓸모있는",
    info: "정보",
    favorite: "즐겨찾는",
    board: "게시판",
    listen_use_board: "Listen use board",
    mid3_secret_board: "Mid3 secret board",
    anonymous_board: "익명 게시글",
    public_board: "공개 게시글",
    info_board: "Info board",
    notice: "공지사항"
  },
  special_lecture: {
    humanitiesCourse: "인문",
    historyCourse: "역사",
    languageCourse: "어학",
    no_lessons: "검색된 강의가 없습니다."
  },
  lecture: {
    state_finish: "완료",
    ele_school: "초등학교",
    middle_school: "중등학교",
  },
}
